import React , { useState,useEffect } from 'react';
import webapi from '../../../api/webapi';
import SearchBody from './SearchBody';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';

const Search = (props) => {
    const [languageInfo,setLanguageInfo] = useState(undefined)
    const [pageData,setPageData] = useState(undefined);

    useEffect(() => {
            async function getLanguageInfo(languageCode){
    
                //console.log('languageCode:',languageCode)
                const responseResultLanguageinfo = await webapi.get('pages/languageInfo/'+languageCode)
                
                const resLanguageinfoData = await responseResultLanguageinfo.data;
    
                //console.log(resLanguageinfoData);
                //console.log(resLanguageinfoData.length);
                
                if (resLanguageinfoData && resLanguageinfoData.length>0)
                {
                    setLanguageInfo(resLanguageinfoData);
                    //setState({lang : responseResultlanguageinfo.data[0].Code});
                    document.getElementsByTagName('html')[0].setAttribute("lang", resLanguageinfoData[0].Code);
                    document.getElementsByTagName('html')[0].setAttribute("dir", resLanguageinfoData[0].Direction);
                }
                else
                {
                    setLanguageInfo([{Code:"fa",Title:"فارسی",Direction:"rtl"}]);
                    //setState({lang : responseResultlanguageinfo.data[0].Code});
                    document.getElementsByTagName('html')[0].setAttribute("lang","fa");
                    document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
                }
            }
    
            async function getLangCodeOfUrl() {
    
                if (new URLSearchParams(props.location.search).get("lang")!=null)
                {
                    //console.log('langFromURL: ',new URLSearchParams(props.location.search).get("lang"));
                    //console.log('langFromSubDomain: ',window.location.host.split(".")[0]);
                    getLanguageInfo(new URLSearchParams(props.location.search).get("lang"));
                    //console.log(languageInfo);
                }else{
                    setLanguageInfo([{Code:"fa",Title:"فارسی",Direction:"rtl"}]);
    
                    document.getElementsByTagName('html')[0].setAttribute("lang","Fa");
                    document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
                }
            }
    
            getLangCodeOfUrl();
        }, []);
    
        // useEffect(()=>{
        //     async function pageList() {
        //         if (languageInfo)
        //         {
        //             const pageList = await webapi.get('pages/datapages/1/'+languageInfo[0].Code);
        //             //console.log('101',pageList);
        //             setPageData(pageList.data);
        //         }else{
        //             const pageList = await webapi.get('pages/datapages/1/fa');
        //             //console.log(pageList);
        //             setPageData('102',pageList.data);
        //         }
    
        //         // const topBooksRes = await webapi.get('book/topbooks/'+languageInfo[0].Code);
        //         // //console.log(TopBooksConst.data[0].FormStatusCode==='BS_Loading');
        //         // setTopBooks(topBooksRes.data);
    
        //         //const wordSummeryRes = await webapi.get('pages/wordsummery');
        //         //console.log(WordSummery.data);
        //         //setWordSummery(wordSummeryRes.data);
        //     }
    
        //     pageList()
        // },[languageInfo])


    
    if (languageInfo) {
        return (
            <div>
                <Header languageInfo = {languageInfo}/>
                <SearchBody languageInfo = {languageInfo} />
                <Footer   lang = {languageInfo[0].Code}/>
            </div>
        )
    }
    else
    {
        return (
            <div></div>
        )
    }
    
 }

 export default Search;